import type { Component } from 'vue'
import { markRaw } from 'vue'

import PaymentMethodPrompt from '~/components/modal/payment-method-prompt.vue'
import { unwrapApiList } from '~/types/api'

const PAYMENT_CHECK_KEY = 'payment-method-prompt-seen'

async function runCheck() {
  const { isAuthenticated } = useSanctumAuth()
  if (!isAuthenticated.value) return

  if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(PAYMENT_CHECK_KEY) === '1') {
    return
  }

  const client = useSanctumClient()

  try {
    const response = await client<{ data: Array<{ verified_at?: string | null }> } | Array<{ verified_at?: string | null }>>(
      '/api/v1/player/payment-methods'
    )
    const list = unwrapApiList<{ verified_at?: string | null }>(response)
    if (list.some(method => typeof method.verified_at === 'string' && method.verified_at.length > 0)) return
  } catch {
    return
  }

  sessionStorage.setItem(PAYMENT_CHECK_KEY, '1')

  const { openModal } = VueModally()
  openModal(markRaw(PaymentMethodPrompt as unknown as Component), { options: { width: 480, padding: 24 }, props: {} })
}

export default defineNuxtPlugin(() => {
  // Delay to allow sanctum initial auth request to complete
  setTimeout(() => {
    void runCheck()
  }, 800)
})
